import { FlexProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCurrentQuote, Proposal } from '../../../../domain'
import { ProductConfig, ProductKind } from '../../../../state/configuration'
import {
  AnnualSummaryPremium,
  DriveawayAdjustedPremium,
  SubscriptionSummaryPremium,
} from '../../../organisms/pricing'

export interface PricingSimpleFactoryProps extends FlexProps {
  proposal: Proposal
  product: ProductConfig
}

export const ProposalDashboardPricing: FunctionComponent<PricingSimpleFactoryProps> = ({
  proposal,
  product,
  ...props
}) => {
  const quote = getCurrentQuote(proposal)

  switch (product.productKind) {
    case ProductKind.ANNUAL:
      return <AnnualSummaryPremium currentQuote={quote} product={product} {...props} />
    case ProductKind.SUBSCRIPTION:
      return (
        <SubscriptionSummaryPremium currentQuote={quote} product={product} {...props} />
      )
    case ProductKind.DRIVEAWAY:
      return (
        <DriveawayAdjustedPremium
          currentQuote={quote}
          product={product}
          policyTerm={proposal.policyTerm}
          {...props}
        />
      )
  }
}
